import type { SearchViewProps } from '../../types';
import * as React from 'react';
import { SearchA as SearchComponent } from '../../containers/SearchA';

export function View(props: SearchViewProps) {
  return (
    <>
      <SearchComponent {...props} />
    </>
  );
}
